import { FilterList, Search } from '@mui/icons-material';
import { SxProps, TextField, Theme } from '@mui/material';
import { useState } from 'react';

import { ColorsRaw } from '@/ui/theme/colors-raw';

interface IProps {
  label: string;
  onChange?: (search: string) => void;
  sx?: SxProps<Theme>;
}

export function FSSearchField({ label, onChange, sx }: IProps) {
  const [search, setSearch] = useState('');

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setSearch(event.target.value);
    if (onChange) onChange(event.target.value);
  };

  return (
    <TextField
      variant="standard"
      placeholder={label}
      sx={{
        ...sx,
        backgroundColor: ColorsRaw.anthracite.Anthracite_3,
        height: 56,
        borderRadius: 28,
        p: 2,
        display: 'flex',
        justifyContent: 'center',
      }}
      inputProps={{
        style: { paddingLeft: 10, paddingRight: 10 },
      }}
      InputProps={{
        startAdornment: <FilterList />,
        endAdornment: <Search />,
        disableUnderline: true,
      }}
      value={search}
      onChange={handleChange}
    />
  );
}
